(() => {
  const viewer = document.querySelector(".reviews-viewer");
  if (!viewer) return;

  const API_KEY = viewer.dataset.apiKey;
  const PLACE_ID = viewer.dataset.placeId;
  const REVIEWS_LIMIT = parseInt(viewer.dataset.reviewsLimit, 10);

  const CACHE_KEY = `googleReviews_${PLACE_ID}`;
  const CACHE_DATE_KEY = `googleReviewsLastUpdate_${PLACE_ID}`;
  const CACHE_TTL = parseInt(viewer.dataset.googleReviewsUpdateTtl, 10) * 60 * 60 * 1000; // 24h

  function isCacheValid() {
    const lastUpdate = localStorage.getItem(CACHE_DATE_KEY);
    if (!lastUpdate) return false;
    return Date.now() - parseInt(lastUpdate, 10) < CACHE_TTL;
  }

  function renderReviews(data) {
    const container = document.getElementById("reviews-grid");
    const reviewsLinkText = document.getElementById("reviews-link-text");
    if (!container || !reviewsLinkText) return;

    container.innerHTML = "";

    data.reviews.slice(0, REVIEWS_LIMIT).forEach(review => {
      const card = document.createElement("div");
      card.className = "review-card";

      const avatar = review.authorAttribution?.photoURI
        ? `<img class="review-avatar" src="${review.authorAttribution.photoURI}" alt="${review.authorAttribution.displayName}">`
        : `<div class="review-avatar fallback"></div>`;

      card.innerHTML = `
        <div class="review-header">
          <div class="review-header-left">${avatar}</div>
          <div class="review-header-right">
            <div class="review-author">${review.authorAttribution.displayName}</div>
            <div class="review-rating">
              ⭐ ${review.rating}/5 - ${review.relativePublishTimeDescription}
            </div>
          </div>
        </div>
        <div class="review-text">${review.text}</div>
      `;

      container.appendChild(card);
    });

    reviewsLinkText.innerText += ` (${data.userRatingCount})`;
  }

  // If Cache is valid then get reviews from localStorage
  if (isCacheValid()) {
    try {
      const cached = JSON.parse(localStorage.getItem(CACHE_KEY));
      if (cached?.reviews?.length) {
        renderReviews(cached);
        return;
      }
    } catch (e) {
      console.warn("Invalid cache, refetching…");
    }
  }

  // Else fetch reviews from Google Place (new) API
  (g=>{var h,a,k,p="The Google Maps JavaScript API",c="google",l="importLibrary",q="__ib__",m=document,b=window;b=b[c]||(b[c]={});var d=b.maps||(b.maps={}),r=new Set,e=new URLSearchParams,u=()=>h||(h=new Promise(async(f,n)=>{await (a=m.createElement("script"));e.set("libraries",[...r]+"");for(k in g)e.set(k.replace(/[A-Z]/g,t=>"_"+t[0].toLowerCase()),g[k]);e.set("callback",c+".maps."+q);a.src=`https://maps.${c}apis.com/maps/api/js?`+e;d[q]=f;a.onerror=()=>h=n(Error(p+" could not load."));a.nonce=m.querySelector("script[nonce]")?.nonce||"";m.head.append(a)}));d[l]?console.warn(p+" only loads once. Ignoring:",g):d[l]=(f,...n)=>r.add(f)&&u().then(()=>d[l](f,...n))})({
      key: API_KEY,
      v: "weekly",
  });


  async function initPlaces() {
    const { Place } = await google.maps.importLibrary("places");

    const place = new Place({ id: PLACE_ID });
    await place.fetchFields({
      fields: ["userRatingCount", "reviews"]
    });

    if (!place.reviews?.length) return;

    const dataToCache = {
      userRatingCount: place.userRatingCount,
      reviews: place.reviews
    };

    localStorage.setItem(CACHE_KEY, JSON.stringify(dataToCache));
    localStorage.setItem(CACHE_DATE_KEY, Date.now().toString());

    renderReviews(dataToCache);
  }

  initPlaces();
})();